export default __webpack_public_path__ + "static/media/960G.9ebbf452.pdf";